import { useState } from 'react';
import { IN_PROGRESS_URL, ACCESS_TYPE } from '../../../../helpers/constants.js';
import { isAMUser, checkCurrentUserFeatureAccess } from '../../../../../../authentication/helpers/utils.js';
import { NOTIFIER_UNAUTHORIZED_MESSAGE, NOTIFIER_UNAUTHORIZED_TITLE, NOTIFIER_UNAUTHORIZED_BUTTON_TEXT } from '../../../../../../authentication/helpers/constants.js';
import { notifier } from '@geit/ui-components';
import 'styled-components';
import '../../../../theme/index.js';
import { showFeatureUnavailable, openExternalPage } from '../../../../helpers/utils.js';
const isPublicFeature = category => {
  return category === ACCESS_TYPE.ALLUSER;
};
const gotoFeature = async _ref => {
  let {
    menuItem: {
      item: {
        isDisableUserPermission,
        featureCode,
        title: featureName,
        external,
        href,
        target,
        windowFeatures
      }
    },
    currentBRN,
    navigate,
    getPermission
  } = _ref;
  if (!isDisableUserPermission) {
    const userPermission = await getPermission({
      featureCode,
      featureName
    }, {
      brn: currentBRN
    });
    if (!(userPermission == null ? void 0 : userPermission.canView) && !(userPermission == null ? void 0 : userPermission.canCreate) && !(userPermission == null ? void 0 : userPermission.canModify) && !(userPermission == null ? void 0 : userPermission.canDelete)) {
      notifier.notify(NOTIFIER_UNAUTHORIZED_MESSAGE, {
        title: NOTIFIER_UNAUTHORIZED_TITLE,
        buttonText: NOTIFIER_UNAUTHORIZED_BUTTON_TEXT
      });
    } else if (external) {
      openExternalPage(href, target, windowFeatures);
    } else {
      navigate(href);
    }
  } else if (external) {
    openExternalPage(href, target, windowFeatures);
  } else {
    navigate(href);
  }
};
const onServiceClick = async _ref2 => {
  let {
    e,
    menuItem,
    currentBRN = "",
    navigate,
    config,
    fetchToken,
    getPermission,
    close,
    onClickMenu
  } = _ref2;
  const {
    item: {
      featureCode,
      href: url,
      category = "",
      title: featureName,
      external
    }
  } = menuItem;
  const [, setError] = useState(null);
  e.preventDefault();
  if (isAMUser() && external) {
    return showFeatureUnavailable();
  }
  if (url !== "") {
    if (onClickMenu) {
      onClickMenu({
        menuItem
      });
    }
    if (url === IN_PROGRESS_URL) {
      navigate(url);
    } else if (url.startsWith("http")) {
      window.open(url);
    } else {
      if (isPublicFeature(category)) {
        gotoFeature({
          currentBRN,
          getPermission,
          menuItem,
          navigate
        });
      } else {
        const token = await fetchToken();
        checkCurrentUserFeatureAccess(token, config, featureCode || featureName).then(value => {
          if (value) {
            gotoFeature({
              currentBRN,
              getPermission,
              menuItem,
              navigate
            });
          }
        }).catch(error => {
          setError(() => {
            throw error;
          });
        });
      }
    }
    if (close) {
      close();
    }
  }
};
export { onServiceClick };